import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $help from './help'

var options: any

export function init($options: any): void {
    options = $options

    $helpers.partialPageInit($('.' + options.pageName + ''))
    $help.tooltips.initializeTooltips($('.' + options.pageName))

    $('.' + options.pageName + ' .bcfla-th-sortable').click(function () {
        $modal.load(
            '/Vehicle/ListVehiclesForOwner',
            {
                id: options.ownerId,
                inuse: options.inUse,
                type: options.type,
                sort: $(this).attr('data-sort'),
            },
            true,
            true,
            true
        )
    })

    $('.' + options.pageName + ' .vehicletypelink').click(function () {
        $modal.load(
            '/Vehicle/ListVehiclesForOwner',
            {
                id: options.ownerId,
                inuse: options.inUse,
                type: $(this).attr('data-type'),
                sort: options.sort,
            },
            true,
            true,
            true
        )
    })
}
